import React, {FC, useEffect, useState} from "react";
import {withFormik} from "formik";
import {Input} from "../../../../commons";
import Validations from "./Validations";
import {useAppSelector} from "../../../../../redux/hooks";
import {createSelector} from "reselect";
import type {RootState} from 'redux/store';
import store from "redux/store";
import {
    IModuleSettings,
    saveModuleSettings,
    setIsOrderModuleSettingsSubmitting,
    setModuleSettings
} from "../../../../../redux/orders/reducer";
import ordersService from "../../../../../api/services/ordersService";
import Error from "../../../../Forms/FormStocksExport/Error";

interface OrderModuleSettingsFormFields extends IModuleSettings {}

interface OrderModuleSettingsFormProps {
    values: OrderModuleSettingsFormFields,
    touched: any,
    errors: any,
    isSubmitting: any,
    handleChange: any,
    handleBlur: any,
    handleSubmit: any,
    resetForm: any,
    toCloseModal: (e: any) => void,
    setFieldValue: any,
    toSubmit: boolean,
}

const initialFields: OrderModuleSettingsFormFields = {
    sellerID: 0,
    combinedStickersProductBarcodeCopies: 1,
}

const memoizedSelector = createSelector(
    (state: RootState) => state.sellers.currentSeller,
    (state: RootState) => state.orders.moduleSettings?.combinedStickersProductBarcodeCopies,
    (currentSeller, combinedStickersProductBarcodeCopies) => ({
        currentSeller,
        combinedStickersProductBarcodeCopies,
    })
);

const InnerFormModuleSettings: FC<OrderModuleSettingsFormProps> = ({
   values,
   touched,
   errors,
   isSubmitting,
   handleChange,
   handleBlur,
   handleSubmit,
   resetForm,
   setFieldValue,
   toSubmit
}) => {

    const [isDataLoading, setIsDataLoading] = useState<boolean>(false);
    const [dataLoadingError, setDataLoadingError] = useState<string>('');

    const {currentSeller, combinedStickersProductBarcodeCopies} = useAppSelector(memoizedSelector)

    useEffect(() => {
        // @ts-ignore
        values.sellerID = currentSeller.info.data.id
        // @ts-ignore
        values.combinedStickersProductBarcodeCopies = combinedStickersProductBarcodeCopies
    }, [currentSeller, combinedStickersProductBarcodeCopies])

    useEffect(() => {

        // Prepare stocks export setting
        ordersService.getModuleSettingsForSeller(values.sellerID)
            .then(
                async (res: { data: { success: boolean, data: IModuleSettings } }) => {
                    if (res.data.success) {
                        store.dispatch(setModuleSettings(res.data.data))

                        setIsDataLoading(false)
                    } else {
                        setDataLoadingError('Не удалось загрузить настройки');
                        setIsDataLoading(false)
                    }
                },
                (err) => {
                    setDataLoadingError(err.response.data.error);
                    setIsDataLoading(false)
                }
            )
            .catch((err) => {
                setDataLoadingError(err.message);
                setIsDataLoading(false);
            })
            .finally(() => {
            })

    }, [])

    useEffect(() => {
        if (toSubmit) {
            handleSubmit()
        }
    }, [toSubmit])

    const customInputClassName = 'border-[#E2E8F0] mb-1 px-3 py-2 rounded-md text-sm shadow-sm placeholder-slate-400  w-full focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none'
    return (
        <form className="w-full">
            {dataLoadingError &&
                <Error message={'Не удалось загрузить настройки. Попробуйте обновить страницу позже'}></Error>
            }
            <div className="mt-4">
                <Input
                    type={`number`}
                    min={1}
                    max={10}
                    id="combinedStickersProductBarcodeCopies"
                    name="combinedStickersProductBarcodeCopies"
                    value={values.combinedStickersProductBarcodeCopies ? values.combinedStickersProductBarcodeCopies.toString() : ''}
                    label={`Число копий ШК`}
                    changeHandler={handleChange}
                    customClassName={customInputClassName}
                    customLabelClassName="text-sm"
                    blurHandler={handleBlur}
                    validationError={touched.combinedStickersProductBarcodeCopies && errors && errors.combinedStickersProductBarcodeCopies && errors.combinedStickersProductBarcodeCopies.length > 0}
                    validationErrorDescription={touched.combinedStickersProductBarcodeCopies ? errors.combinedStickersProductBarcodeCopies : ''}
                    require={false}
                    disabled={isDataLoading}
                />
            </div>

            {errors.name && touched.name && <div id="feedback">{errors.name}</div>}

        </form>
    )
}
const FormOrderModuleSettings = withFormik({
    enableReinitialize: true,

    mapPropsToValues: () => (initialFields),

    // Custom sync validation
    validate: values => {
        const errors = {};

        const validation = Validations();

        //@ts-ignore
        Object.keys(values).forEach((key) => validation[key] && validation[key](errors, values[key]))


        return errors;
    },

    handleSubmit: (values, {setSubmitting}) => {
        setSubmitting(true);
        store.dispatch(setIsOrderModuleSettingsSubmitting(true))
        setTimeout(() => {
            //@ts-ignore
            store.dispatch(saveModuleSettings(values))

            setSubmitting(false);
        }, 500)
    },

    displayName: 'BasicForm',
})(InnerFormModuleSettings);

export default FormOrderModuleSettings;